import React from 'react';
import '../styles/SitePanel.css';

export default function SitePanel({ site, onClose, onModeChange, onGetDomain }) {
  if (!site) return null;

  const visitUrl = site.custom_domain
    ? `https://${site.custom_domain}`
    : site.url;
  const hasDomain = !!site.custom_domain;

  return (
    <div className="site-panel">
      <div className="site-panel-header">
        <h3 className="site-panel-title">Quick Actions</h3>
        {onClose && (
          <button className="site-panel-close" onClick={onClose}>×</button>
        )}
      </div>

      <div className="site-panel-content">
        <div className="site-panel-actions">
          {visitUrl && (
            <a
              href={visitUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="site-panel-btn"
            >
              Visit Site →
            </a>
          )}
          {!hasDomain && onGetDomain && (
            <button
              className="site-panel-btn"
              onClick={() => onGetDomain(site.site_id, site.conversation_id)}
            >
              Get a Domain →
            </button>
          )}
          {onModeChange && (
            <button
              className="site-panel-btn"
              onClick={() => onModeChange('conversations')}
            >
              Return to Conversations →
            </button>
          )}
        </div>

        <div className="site-panel-section">
          <h4 className="site-panel-section-title">Linked Domain</h4>
          {site.linked_domain ? (
            <button
              className="site-panel-domain-link"
              onClick={() => {
                if (onModeChange) onModeChange('domains', { domainName: site.linked_domain });
              }}
            >
              {site.linked_domain} →
            </button>
          ) : (
            <p className="site-panel-muted">No domain linked</p>
          )}
        </div>
      </div>
    </div>
  );
}
